import Head from "next/head";
import React from "react";
import { OneColumnContainer } from "../components/ColumnContainers/OneColumnContainer";
import { ComponentContainer } from "../components/ComponentContainer";
import { ComponentHeader } from "../components/ComponentHeader";
import Layout from "../components/Layout";

const Item = ({ href, target, rel, children }) => (
  <a
    href={href}
    target={target}
    rel={rel}
    className="flex bg-black grow h-[70px] rounded-[8px] no-underline"
  >
    <div className="font-['Montserrat'] font-bold text-[16px] text-center text-white uppercase grow self-center">
      {children}
    </div>
  </a>
);

export default function Contact() {
  return (
    <Layout title="GolfChamps | Contact Us">
      <OneColumnContainer>
        <ComponentContainer>
          <ComponentHeader text="Contact Us" />
          <div className="flex flex-col sm:flex-row content-center justify-items-center mt-[32px] gap-[16px]">
            <Item
              href="mailto:info@golfchamps.net"
              target="_blank"
              rel="noopener noreferrer"
            >
              Email
            </Item>
            <Item
              href="http://www.twitter.com/Golfchamps_"
              target="_blank"
              rel="noopener noreferrer"
            >
              X
            </Item>
            <Item
              href="https://www.instagram.com/golf_champs"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </Item>
            <Item
              href="http://www.facebook.com/GolfChamps"
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </Item>
          </div>
        </ComponentContainer>
      </OneColumnContainer>
    </Layout>
  );
}
